import { useEffect, useState } from "react";
import ResponsableInstalacionForm from "./ResponsableInstalacionForm";

const initialValues = {
    cuitResponsable: "",
    numeroLicenciaHabilitante: "",
    domicilioHabilitacion: "",
    fechaExpedicion: null,
    fechaVencimiento: null,
};

const ResponsableInstalacionFormContainer = ({ open, handleClose, handleSubmit, values }) => {

    const [formInitialValues, setFormInitialValues] = useState();

    useEffect(() => {
        if (values) {
            setFormInitialValues({
                ...values,
                cuitResponsable: (values.cuitResponsable || "").replace(/[-\s]/g, "")
            });
        } else {
            setFormInitialValues(initialValues)
        }
    }, [values])

    return (
        <ResponsableInstalacionForm
            open={open}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            values={formInitialValues}
        />
    )
}


export default ResponsableInstalacionFormContainer;